var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownFilled = function SvgArrowDownFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 20c5.52 0 10-4.48 10-10s-4.48-10-10-10S.5 4.48.5 10s4.48 10 10 10M6.97 9.97c.15-.15.34-.22.53-.22s.38.07.53.22l1.72 1.72V6.5c0-.41.34-.75.75-.75s.75.34.75.75v5.19l1.72-1.72c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-3 3c-.29.29-.77.29-1.06 0l-3-3a.754.754 0 0 1 0-1.06"
  })));
};
export default SvgArrowDownFilled;